import {
    RETRIEVE_STORAGE_TYPES,
    CREATE_STORAGE_TYPE,
    UPDATE_STORAGE_TYPE,
    DELETE_STORAGE_TYPE,
    RESTORE_STORAGE_TYPE,
    UPDATE_STORAGE_TYPE_STATUS,
} from "../actions/types";
  
const initialState = { storageTypes : [], totalStorageCount : 0 };

const storageTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_STORAGE_TYPES:
      return {
        storageTypes: payload.rows,
        totalStorageCount: payload.count,
      };

    case CREATE_STORAGE_TYPE:
      return payload;

    case UPDATE_STORAGE_TYPE:
      return payload;

    case UPDATE_STORAGE_TYPE_STATUS:
      return {
        storageTypes: payload.rows,
        totalStorageCount: payload.count,
      };

    case DELETE_STORAGE_TYPE:
      return {
        storageTypes: payload.rows,
        totalStorageCount: payload.count,
      };

    case RESTORE_STORAGE_TYPE:
      return {
        storageTypes: payload.rows,
        totalStorageCount: payload.count,
      };

    default:
      return state;
  }
};

export default storageTypeReducer;